/**
 * "Learn this": a small link from a place in the app into the lesson that explains it.
 * Renders nothing when the training is switched off.
 */

import { GraduationCap, Icon } from "@norican/icons";
import { cn } from "@norican/react";
import { Link } from "react-router";

import { FEATURES } from "@/lib/features";

import { TRAINING_LINKS } from "./content";
import { trainingHref } from "./player/progress";
import { plainText } from "./player/text";
import type { LinkSpot } from "./types";

export { trainingHref };

export interface LearnThisLinkProps {
  spot: LinkSpot;
  /** A sentence before the link, e.g. "Closed does not mean answered." */
  lead?: string;
  className?: string;
}

export function LearnThisLink({ spot, lead, className }: LearnThisLinkProps) {
  if (!FEATURES.training) {
    return null;
  }
  const target = TRAINING_LINKS[spot];
  if (!target) {
    return null;
  }
  return (
    <span
      className={cn(
        "text-fg-muted inline-flex flex-wrap items-center gap-x-1.5 text-xs",
        className,
      )}
      data-learn-this={spot}
    >
      {lead && <span>{lead}</span>}
      <Link
        to={trainingHref(target)}
        className="text-accent-fg-subtle inline-flex items-center gap-1 font-semibold hover:underline"
      >
        <Icon icon={GraduationCap} size="xs" aria-hidden />
        {plainText(target.text)}
      </Link>
    </span>
  );
}
